import { creatorbase } from '@round/api';

export default {
    action_needed: {
        color: '#FF5050',
        background: 'rgba(254, 0, 43, 0.2)',
    },
    cancelled: {
        color: 'var(--text-white)',
        background: 'var(--Badges-Completed)',
    },
    pending: {
        color: 'var(--Text-orange)',
        background: 'var(--Badges-Pending)',
    },
    confirmed_to_bill: {
        color: 'rgba(147, 106, 0, 1)',
        background: 'rgba(255, 184, 0, 0.4)',
    },
    invoiced: {
        color: 'var(--Text-success)',
        background: 'var(--Badges-LightGreen)',
    },
} as Record<creatorbase.FinanceStatus, { background: string; color: string }>;
